import {
  Flex,
  VStack,
  Button,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useEditState from '../../../../../../common/src/hooks/useEditState';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { CompanyLease } from '../../../../types/CompanyScanTypes';
import CompanyLeaseTable from './CompanyLeaseTable';
import NewCompanyLeaseModal from './NewCompanyLeaseModal';

interface Props {
  question: FlowsQuestion;
}

const CompanyLeaseInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { toBeEdited, setToBeEdited, editIndex, setEditIndex } =
    useEditState<CompanyLease>();

  const {
    field: { value, onBlur },
    // error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const companyLeases = (value as CompanyLease[] | undefined) || [];

  const addCompanyLease = (companyLease: CompanyLease) => {
    onBlur({ name: question.id, value: [...companyLeases, companyLease] });
  };

  const editCompanyLease = (companyLease: CompanyLease, index: number) => {
    if (index > -1) {
      const newCompanyLeases = [...companyLeases];
      newCompanyLeases[index] = companyLease;
      onBlur({ name: question.id, value: newCompanyLeases });
    }
  };

  const handleOnRemove = (index: number) => {
    onBlur({
      name: question.id,
      value: companyLeases.filter((_, _index) => _index !== index),
    });
  };

  const handleOnEdit = (companyLease: CompanyLease, index: number) => {
    setToBeEdited(companyLease);
    setEditIndex(index);
    onOpen();
  };

  const handleOnClose = () => {
    setToBeEdited(undefined);
    setEditIndex(undefined);
    onClose();
  };

  return (
    <VStack spacing="4" align="stretch">
      {isOpen && (
        <NewCompanyLeaseModal
          companyLease={toBeEdited}
          isOpen={isOpen}
          onClose={handleOnClose}
          addCompanyLease={addCompanyLease}
          editCompanyLease={(lease) => editCompanyLease(lease, editIndex || 0)}
        />
      )}
      <CompanyLeaseTable
        companyLeases={companyLeases}
        onEdit={handleOnEdit}
        onRemove={handleOnRemove}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          isDisabled={question.rules.is_disabled}
        >
          {t('FLOWS_COMPANY-SCAN_COMPANY-LEASE-INPUT_ADD-LEASE')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default CompanyLeaseInputComponent;
